











































































import { Component, Mixins, Prop, Watch } from 'vue-property-decorator';
import MixinChartRaw from '../../../plugins/podolib/services/helper/mixins/chart/raw';

@Component
export default class ChartRunningPhaseResume extends Mixins(MixinChartRaw) {
  @Prop({ required: true, default: true }) globalType!: boolean;
  @Prop({ default: 0 }) index!: number;

  getData(side: string, data: string) {
    return this.globalType
      ? this.values.aggregates[side][data].avg.toFixed(1)
      : this.values.segments[this.index][side].result.aggregates[data].avg.toFixed(data === 'stride_length' ? 1 : 0);
  }
  getDoubleContact(side: string) {
    return ((this.getData(side, 'percent_flight_time') - this.getData(side, 'percent_contact_time')) / 2).toFixed(0);
  }
  getForeFoot(side: string) {
    let count: number = 0;
    for (const seg of this.values.segments) {
      if (seg[side].result.scalars.fore_foot) count + 1;
    }
    if (this.values.segments.length / 2 < count) {
      return this.globalType ? true : this.values.segments[this.index][side].result.scalars.fore_foot;
    } else {
      return this.globalType ? false : this.values.segments[this.index][side].result.scalars.fore_foot;
    }
  }
}
